import { graphql, useStaticQuery } from 'gatsby'
import React, { useMemo } from 'react'
import { slugify } from '../functions'
import { ArticleClass, WebProject } from '@types'

type UseGetProjects = () => {
    getProject: (projectId: string) => any
    projects: any[]
}

const useGetProjects: UseGetProjects = () => {
    const data = useStaticQuery(graphql`
        query GetProjects {
            shd {
                objects {
                    findArticle(where: { module: { _eq: "Mv22pcTQUp" } }) {
                        results {
                            objectId
                            title
                            text
                            createdAt
                            updatedAt
                            image
                            categories
                            date
                            data
                        }
                    }
                }
            }
        }
    `)

    const getProject = (projectId: string) => {
        const projects = data.shd.objects.findArticle.results
        return projects.find((project: any) => project.objectId === projectId)
    }

    const articles = data.shd.objects.findArticle.results

    const projects = useMemo(() => {
        const projectsArray: WebProject[] = [];
        articles.forEach((article: ArticleClass) => {
            projectsArray.push({
                title: article.title,
                slug: slugify(article.title),
                image: article.image,
                description: article.text,
                date: article.date,
                id: article.objectId,
                preview: article.data?.vorschaubild[0]
            })
        })
        
        return projectsArray;
    }, []);


    return {
        getProject,
        projects,
    }
}

export default useGetProjects